import styled from 'styled-components';

export const Wrapper = styled.div`
    background-color: #fff;
    align-items: baseline;
    display: grid;
    margin-left: 10px;
    width: 300px;
    margin-top: 10px;
    grid-template-rows: 0.2fr 5fr 0.2fr;
    box-shadow: 0px 2px 20px hsl(0deg 0% 0% / 0.35);
`;

export const Footer = styled.div`
    background-color: #E03B3E;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    font-weight: bold;
    color: #fff;
`;

export const Header = styled.div`
    // background-color: #585DCE;
    background-color: #029100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    font-weight: bold;
    color: #fff;
`;

export const Content = styled.div`
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    font-weight: bold;
    color: #fff;
`;